import React, { useState } from "react";

import { Grid, Typography, Box } from "@mui/material";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

const show = {
  position: "absolute",
  bottom: 24,
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  zIndex: 100,
};
const linkStyle = {
  width: "100%",
  display: "block",
  height: "100%",
  position: "relative",
};

const ProjectPost = ({ node, i }) => {
  const [currentImage, setCurrntImage] = useState(0);
  const hide = { display: "none" };
  const { frontmatter } = node;
  return (
    <Grid
      item
      key={node.id}
      xs={12}
      sm={6}
      md={6}
      lg={4}
      onMouseEnter={() => {
        setCurrntImage(i + 1);
      }}
      onMouseLeave={() => setCurrntImage(0)}
    >
      <Link to={`${frontmatter.slug}`} style={linkStyle}>
        <Box sx={currentImage === i + 1 ? show : hide}>
          <Typography variant="h4" color="primary">
            {frontmatter.title}
          </Typography>
          <Typography variant="subtitle1">{frontmatter.tags}</Typography>
        </Box>
        <GatsbyImage
          image={frontmatter.featuredImage.childImageSharp.gatsbyImageData}
          alt={frontmatter.title || "Featured project cover image"}
          style={{ marginTop: 48 }}
          className="featured-image"
        />
      </Link>
    </Grid>
  );
};

export default ProjectPost;
